import { render } from "./Meigaranewsrecentl_quick.vue?vue&type=template&id=5fa34391&scoped=true"
import script from "./Meigaranewsrecentl_quick.vue?vue&type=script&lang=js"
export * from "./Meigaranewsrecentl_quick.vue?vue&type=script&lang=js"

import "./Meigaranewsrecentl_quick.vue?vue&type=style&index=0&id=5fa34391&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa34391"]])

export default __exports__